import axiosInstance from '@/api/axiosInstance';
import {
  BenefitSearchParams,
  BenefitListResponse,
  BenefitListApiResponse,
  BenefitDetailApiResponse,
  BenefitRecord,
  BenefitFormData,
  BenefitTypeOption,
} from './types';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 获取会员权益列表
 */
export const getBenefitList = async (
  params: BenefitSearchParams
): Promise<BenefitListResponse> => {
  const response = await axiosInstance.get<BenefitListApiResponse>(
    `${baseUrl}/memberPrivilege/v1/pageList`,
    {
      params: {
        currentPage: params.currentPage || 1,
        pageSize: params.pageSize || 10,
      },
    }
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取会员权益列表失败');
};

/**
 * 获取会员权益详情
 */
export const getBenefitDetail = async (id: number): Promise<BenefitRecord> => {
  const response = await axiosInstance.get<BenefitDetailApiResponse>(
    `${baseUrl}/memberPrivilege/v1/detail`,
    {
      params: {
        id,
      },
    }
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取会员权益详情失败');
};

/**
 * 创建会员权益
 */
export const createBenefit = async (
  data: BenefitFormData
): Promise<{ success: boolean; message: string }> => {
  console.log(data, "datad");
  const response = await axiosInstance.post<{
    status: number;
    success: boolean;
    message: string;
  }>(`${baseUrl}/memberPrivilege/v1/add`, data);

  if (response.data.success) {
    return { success: true, message: '创建成功' };
  }

  throw new Error(response.data.message || '创建失败');
};

/**
 * 更新会员权益
 */
export const updateBenefit = async (
  id: number,
  data: BenefitFormData
): Promise<{ success: boolean; message: string }> => {
  const response = await axiosInstance.post<{
    status: number;
    success: boolean;
    message: string;
  }>(`${baseUrl}/memberPrivilege/v1/edit`, { ...data, id });

  if (response.data.success) {
    return { success: true, message: '更新成功' };
  }

  throw new Error(response.data.message || '更新失败');
};

/**
 * 获取会员权益类型列表（用于下拉选择）
 */
export const getBenefitTypeList = async (): Promise<BenefitTypeOption[]> => {
  const response = await axiosInstance.get<{
    status: number;
    success: boolean;
    message: string;
    data: BenefitTypeOption[];
  }>(`${baseUrl}/memberPrivilege/v1/getPrivilegeTypeList`);

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取会员权益类型列表失败');
};

